import React from "react";
import {
  ActiveIndicator,
  ChildListItemContainer,
  ContainerIconList,
  LiItem,
  TitleItem,
} from "../style/style";
import { ChildItem, SidebarItem } from "../interface";
import { SvgIcon } from "../components/SvgIcon";

export const ItemListChild = (props: {
  isHiddenList: Record<string, boolean>;
  item: SidebarItem;
  childItem: ChildItem;
  activeItem?: string | null;
  selectedItem?: (item: ChildItem) => void;
  isHidden?: boolean;
}) => {
  const isActive = props.activeItem === props.childItem.id;
  const isHidden = props.isHidden;

  return (
    <ChildListItemContainer
      isHiddenList={props.isHiddenList[props.item.id]}
      key={props.childItem.id}
      isHidden={isHidden}
    >
      <LiItem
        isHidden={props.isHidden}
        isActive={isActive}
        color={"#E9F3FF"}
        onClick={() => {
          props.selectedItem?.(props.childItem);
        }}
      >
        <ContainerIconList>
          <SvgIcon
            iconUrl={props.childItem.icon}
            color={props.childItem.color || "#3F3F46"}
            activeColor={props.childItem.activeColor || "#0076FF"}
            isActive={isActive}
            width="100%"
            height="100%"
          />
        </ContainerIconList>
        <TitleItem isHidden={props.isHidden} isActive={isActive}>
          {props.childItem.title}
        </TitleItem>
        <ActiveIndicator isActive={isActive} />
      </LiItem>
    </ChildListItemContainer>
  );
};
